import PropTypes from 'prop-types';

export const propTypes = {
    onAddTextToCanvas: PropTypes.func,
    languageLocale: PropTypes.string,
};
